var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1062 25.2249L26.431 24.9195C26.1165 24.8825 25.7976 24.9173 25.4984 25.0213C25.1993 25.1253 24.9276 25.2957 24.7037 25.5198L22.7658 27.4578C19.7758 25.9371 17.3456 23.5069 15.825 20.5169L17.7735 18.5684C18.2263 18.1156 18.4475 17.4836 18.3738 16.8411L18.0684 14.187C18.0086 13.6732 17.7621 13.1993 17.3756 12.8555C16.9891 12.5118 16.4897 12.3221 15.9724 12.3228H14.1503C12.9602 12.3228 11.9702 13.3128 12.0439 14.503C12.6021 23.4976 19.7957 30.6807 28.7797 31.2389C29.9699 31.3126 30.9599 30.3226 30.9599 29.1324V27.3103C30.9704 26.2465 30.17 25.3513 29.1062 25.2249Z",
    fill: "#56AAFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.7827,
    r: 20.5,
    stroke: "#56AAFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneimg);
export default __webpack_public_path__ + "static/media/phoneimg.8c0f8a5f5581d952a19199b4daeb53fe.svg";
export { ForwardRef as ReactComponent };